export async function runWithNotification({
  fn,
  successMessage,
  errorMessage,
  onSuccess,
  setNotification,
  onError,
}) {
  try {
    const result = await fn();
    if (onSuccess) onSuccess(result);

    setNotification({
      visible: true,
      success: true,
      title: "Success",
      message: successMessage,
    });
  } catch (err) {
    if (onError) onError(err);

    setNotification({
      visible: true,
      success: false,
      title: "Error",
      message: errorMessage,
    });
  }

  setTimeout(() => {
    setNotification((prev) => ({ ...prev, visible: false }));
  }, 4000);
}
